import { microsoftGraphAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const MAIL_CREATE_RESOURCE = "messages" as const;
export const MAIL_CREATE_API_PATH = "/v1.0/me/messages" as const;

export interface EmailBody {
  content: string;
  contentType: "HTML" | "Text";
}

export interface EmailRecipient {
  emailAddress: {
    address: string;
  };
}

export interface MutationBody {
  body: EmailBody;
  subject: string;
  toRecipients: EmailRecipient[];
}

export interface MutationResponse {
  id: string;
  webLink: string;
  subject: string;
  body: EmailBody;
  toRecipients: EmailRecipient[];
  createdDateTime: string;
}

export const useMailCreateMutation = () => {
  return useMutation<MutationResponse, Error, MutationBody>({
    mutationFn: async (email: MutationBody): Promise<MutationResponse> => {
      const response = await microsoftGraphAxios.post<MutationResponse>(MAIL_CREATE_API_PATH, email, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    },
  });
};
